import PropTypes from "prop-types";
import React from 'react'
import { Box, Modal, Typography } from '@mui/material'
import closeIcon from '../../../assets/icons/closeIcon.svg'

const TermsAndConditionsModal = ({ termsAndConditionModal, setTermsAndConditionModal, termsAndConditionsData }) => {
    
     const getProcessedContent = (data) => {
        if (!data) return null;
   
        if (/<[a-z][\s\S]*>/i.test(data)) {
            return data;
        }

        return data.replaceAll(/\n/, '<br />');
    };

    const processedContent = getProcessedContent(termsAndConditionsData);
    return (
        <Modal
            open={termsAndConditionModal}
            onClose={() => setTermsAndConditionModal(false)}
            aria-labelledby="terms-title"
            aria-describedby="terms-description"
        >
            <Box
                sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    maxWidth: 635,
                    maxHeight: 550,
                    overflowY: 'auto',
                    bgcolor: "background.paper",
                    borderRadius: 2,
                    boxShadow: 24,
                    p: 4,
                }}
            >
                <Box mb={4} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                    <Typography id="terms-title" sx={{ fontSize: '16px', fontWeight: 600, }} >
                       Terms & Conditions
                    </Typography>
                    <button
                        onClick={() => setTermsAndConditionModal(false)}
                        style={{
                            background: 'none',
                            border: 'none',
                            padding: 0,
                            cursor: 'pointer',
                        }}
                    >
                        <img src={closeIcon} alt="close" />
                    </button>
                </Box>
                 {processedContent ? (
                    <Box
                        id="terms-description"
                        dangerouslySetInnerHTML={{ __html: processedContent }}
                     
                    />
                )  : (
                    <Typography id="terms-description" variant="body2" sx={{ fontWeight: 500 }}>
                        No Terms & Conditions available.
                    </Typography>
                )}
            </Box>
        </Modal>
    )
}



TermsAndConditionsModal.propTypes = {
  setTermsAndConditionModal: PropTypes.func,
  termsAndConditionModal: PropTypes.any,
  termsAndConditionsData: PropTypes.object,
};

export default TermsAndConditionsModal